// https://github.com/Anidetrix/rollup-plugin-styles/blob/main/runtime/inject-css.js
const parents = new WeakMap();
function getContainer(selector) {
    var _a;
    return (_a = document.querySelector(selector)) !== null && _a !== void 0 ? _a : document.head;
}
function insertStyleTag(parent, insertPosition, attributes) {
    const el = document.createElement('style');
    el.setAttribute('type', 'text/css');
    Object.entries(attributes).forEach(([key, value]) => el.setAttribute(key, value));
    parent.insertAdjacentElement(insertPosition, el);
    return el;
}
function insertStyleTagSingle(parent, insertPosition, attributes) {
    if (!parents.has(parent))
        parents.set(parent, {});
    const positions = parents.get(parent);
    const el = positions[insertPosition];
    if (el)
        return el;
    const newEl = insertStyleTag(parent, insertPosition, attributes);
    positions[insertPosition] = newEl;
    return newEl;
}
/**
 * @param {string} css
 * @param {object} options
 */
export default function injectCss(css, { singleTag = false, prepend = false, container: selector = 'head', attributes = {}, } = {}) {
    if (!css || typeof document === 'undefined')
        return;
    const insertPosition = prepend ? 'afterbegin' : 'beforeend';
    const parent = getContainer(selector);
    const styleTag = singleTag
        ? insertStyleTagSingle(parent, insertPosition, attributes)
        : insertStyleTag(parent, insertPosition, attributes);
    // strip potential UTF-8 BOM if css was read from a file
    if (css.charCodeAt(0) === 0xfeff)
        css = css.substring(1);
    styleTag.appendChild(document.createTextNode(css));
}
//# sourceMappingURL=injectCss.js.map